import { initItemPage } from 'src/lib/item-page.js'

initItemPage()
